import store from 'app/store';
import { MediaFile } from 'resources';
import Encoder from 'services/encoder';

function forceReadMediaFile(episodeId) {
  return store.dispatch(MediaFile.read(episodeId, true));
}

export default async (episodeId, mediaUrl, force = false) => {
  const state = store.getState();
  const episode = state.episode.get(episodeId);

  const jobParams = {
    episode: episode.id,
    show: episode.show,
    media: mediaUrl,
  };

  /* eslint-disable no-unused-expressions */
  await Encoder.encode(jobParams, force);
  const mediaFile = await forceReadMediaFile(episodeId);
  /* eslint-enable no-unused-expressions */

  return mediaFile;
};
